






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "bread-crumbs"
})
export default class BreadCrumbs extends Vue {
  @Prop({type: [Array], default: []}) protected items!: any
  @Prop({type: String, default: ''}) value !:any



}
